import constantsInfo from '@/constants/index';
import { ElMessage } from "element-plus";
/**
 * 内容是否包含url
 * @param {*} url 
 * @returns 
 */
export function isIncludesURL(url) {
    if (!url) {
        return false
    }
    const enhancedUrlPattern = /(https?:\/\/|\/\/)([\w-]+(\.[\w-]+)+)(:\d+)?(\/[\w\-\\.%&=]*)?/gi;

    return enhancedUrlPattern.test(url);
}


/**
 * 发送消息内容检测
 * @param {*} platTypeId 
 * @param {*} msgData 
 */
function sendMsgCheck(msgData, platTypeId) {
    if (!msgData) {
        return true
    }
    //网页放行
    if ((constantsInfo.MSG_TYPE.TYPE_3.value+"") != platTypeId) {
        if (isIncludesURL(msgData)){
            ElMessage.error("请遵守平台私信安全规定，私信消息不允许发送包含（URL）消息。");
            return false
        }
    }
    return true
}
export default {
    isIncludesURL,
    sendMsgCheck
}